import React from 'react';
import { Sparkles } from 'lucide-react';

const items = [
  'ESG-as-Code®',
  'Seven live frameworks',
  '90+ deterministic rules',
  'Clause-traceable outcomes',
  'Audit-ready exports',
  'CSRD · SEC · ISSB · SFDR · CARB · FCA',
  'We do not score ESG. We enforce it.',
];

export default function Marquee() {
  const seq = [...items, ...items];
  return (
    <div className="w-full bg-[#0B1F2D] text-[#FAFAF5] border-b border-[#0B1F2D] overflow-hidden">
      <div className="flex items-center gap-3 py-2.5 marquee-track whitespace-nowrap">
        {seq.map((t, i) => (
          <span key={i} className="inline-flex items-center gap-3 text-[12px] tracking-[0.14em] uppercase text-[#FAFAF5]/80">
            <Sparkles className="w-3 h-3 text-[#7BC2B0]" />
            <span>{t}</span>
            <span className="text-[#FAFAF5]/30 px-3">/</span>
          </span>
        ))}
      </div>
    </div>
  );
}
